module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "tick.8befb6e6.svg";